var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "text-area-wrapper" }, [
    _c(
      "div",
      {
        ref: "numbers",
        staticClass: "leading-tight numbers-input",
        class: _vm.value.length === 0 && "light",
      },
      [_vm._v("\n        " + _vm._s(_vm.adjustedNumbers) + "\n    ")]
    ),
    _vm._v(" "),
    _c("textarea", {
      staticClass: "leading-tight main-input",
      attrs: { name: "main-input", placeholder: _vm.placeholder },
      domProps: { value: _vm.value },
      on: {
        keyup: function ($event) {
          return _vm.keyUp($event)
        },
        change: function ($event) {
          return _vm.keyUp($event)
        },
        input: function ($event) {
          return _vm.keyUp($event)
        },
        scroll: function ($event) {
          return _vm.sync($event)
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }